import { Box, Modal, IconButton, Typography, Fade, Backdrop } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { ConversationList } from "./components/chatCenter/ConversationLeft";
import { ChatWindow } from "./components/chatCenter/conversationWindow";

export const ChatCenter = ({ userType }) => {
  const [open, setOpen] = useState(false);
  const [selectedConversation, setSelectedConversation] = useState(null);

  return (
    <>
      {/* Floating Chat Button */}
      <Box
        onClick={() => setOpen(true)}
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          width: 56,
          height: 56,
          borderRadius: "50%",
          bgcolor: "primary.main",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          boxShadow: "0px 8px 24px rgba(0,0,0,0.2)",
          transition: "transform 0.2s ease",
          "&:hover": {
            transform: "scale(1.05)",
          },
        }}
      >
        <ChatBubbleOutlineIcon />
      </Box>

      {/* Chat Modal */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 300 }}
      >
        <Fade in={open}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "95%", md: 900 },
              height: { xs: "85vh", md: 560 },
              bgcolor: "background.paper",
              boxShadow: "0px 20px 60px rgba(0,0,0,0.25)",
              borderRadius: 3,
              display: "flex",
              flexDirection: "column",
              outline: "none",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                px: 2,
                py: 1.5,
                borderBottom: "1px solid",
                borderColor: "divider",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography fontWeight={600}>Chat Center</Typography>
              <IconButton size="small" onClick={() => setOpen(false)}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            {/* Content */}
            <Box sx={{ flex: 1, display: "flex", overflow: "hidden" }}>
              {/* Conversation List */}
              <ConversationList
                onSelect={setSelectedConversation}
                selected={selectedConversation}
              />

              {/* Chat Window */}
              {selectedConversation ? (
                <ChatWindow
                  conversation={selectedConversation}
                  userType={userType}
                />
              ) : (
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "text.secondary",
                    fontSize: "0.95rem",
                  }}
                >
                  Select a conversation to start chatting
                </Box>
              )}
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
